import React from 'react';
import tubulin from '../images/tubulins.gif';

class AboutChallenge extends React.Component {

    render() {
        return (
        <div>
            <h3 style={{"paddingTop":"20px"}}>About</h3>
            <img src={tubulin} className="frame" style={{"float":"right"}}/> 
            <p>
            With the widespread uptake of 2D and 3D single molecule localization microscopy, a large set of 
            different data analysis packages have been developed to generate super-resolution images. To guide 
            researchers on the optimal analytical software for their experiments, we have designed, in a large 
            community effort, a competition to extensively characterise and rank these options. We generated 
            <a href="#" onClick={()=>this.props.history.push('/Challege/ChallengeData')}> realistic simulated datasets</a> for popular imaging modalities - 2D, astigmatic 3D, biplane 3D, and double helix 3D - 
            and initially evaluated 36 participant packages against these data. This provides the first broad assessment 
            of 3D single molecule localization microscopy software, provides a holistic view of how the latest 2D and 3D 
            single molecule localization software perform in realistic conditions, and ultimately provides insight into the 
            current limits of the field. 
            </p>
            <p>
            The results were published in Nature Methods: 
            <a href="https://www.nature.com/articles/s41592-019-0364-4">Super-resolution fight club: A broad assessment of 2D & 3D single-molecule localization microscopy software</a>. 
            </p>
            <hr className="bold"></hr>
            <div className="introduction">
                <div className="container">
                    <div className="row">
                        <p>Sage, D., Pham, T., Babcock, H. et al. Super-resolution fight club: assessment of 2D and 3D single-molecule localization microscopy software. 
                            Nat Methods 16, 387–395 (2019). https://doi.org/10.1038/s41592-019-0364-4</p>
                    </div>
                </div>
                </div>
            <hr className="bold"></hr>
            <p>
            The competition website is continuously updated with contributions from new 
            <a href="#" onClick={()=>this.props.history.push('/SoftwareList')}> softwares</a>, so keep an 
            eye on the competition results page to stay up to date with the latest developments.
            </p>

            <div style={{"height":"10px"}}></div> 
            <h3 style={{"paddingTop":"20px"}}>Participation</h3> 
                The challenge is open to all individuals or teams, academic or corporate, existing or 
                newly developed localization microscopy software. Participation is free.
                
                <p>The challenge is turn on as a permanent challenge.</p>
                
                <p><b>How to register?</b>
                    To announce your participation,  
                    <a href="mailto:daniel.sage@epfl.ch?subject=Pre-registration to Single-Molecule Localization Microscopy Challenge&body=Please, indicate the name of the software and the name of the contact person."> 
                    send an email</a> to indicating the name  of the software that you want to represent and the name of a contact person.
                </p>
            <div style={{"height":"10px"}}></div> 
            <div>

            <h4 style={{"clear":"both"}}>How to participate?</h4>

            <ul>
            <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>Pre-register by send an email with the name of the software and a contact name</li>
            <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>Choose one or several modalities: 2D, AS (3D-astigmatism), DH (3D-double-helix) or BP (3D-biplane)</li>
            <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>Download the datasets and the z-stack of beads for your calibration.</li>
            <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>Submit your documents</li>

            </ul>

            <h4 style={{"clear":"both"}}>Documents to submit</h4>
                
                <ul>
                <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>3 questionnaires, general information, usability, and computational time</li>
                <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>1 wobble correction process: localization on the z-stack of beads, wooble correction file, or localization already corrected by the software</li>
                <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>4 localization files of a given category/modality
                    <ul style={{"paddingLeft":"16px"}}>
                    <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>File format: the results of the localization are given in a delimiter-separated values text file, typically in a coma-separated values (CSV) 
                    or tab-separated values (TSV/TAB). The unreadable lines are discarded (e.g. NaN).</li>
                    <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>At least the following columns: X, Y, Z, frame, number of photons. The organizers reserve the right to permute the columns.</li>
                    <li style={{"padding":"0px","margin":"0px 0px 0px 10px"}}>To better fit the same origin, the organizers reserve the right to apply the following offset: -50nm on X (1/2 pixel), -50nm on Y (1/2 pixel), 
                    -750 nm (focal plane at 750nm), +1 frame (index of first frame is 1).</li>
                    </ul>
                </li>
                </ul>
            

            </div>
                
            <div style={{"height":"10px"}}></div> 

            {/*}
            <script type="text/javascript">
            document.getElementById('forum_embed').src =
                'https://groups.google.com/forum/embed/?place=forum/lm-challenge-discuss'
                + '&showsearch=true&showpopout=true&showtabs=true'
                + '&parenturl=' + encodeURIComponent(window.location.href);
            </script>
            */}
        </div>
      );
    }
}

export default AboutChallenge;